var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#00838D",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5053 14.3987C29.1212 14.7828 28.7484 15.1555 28.7371 15.5283C28.7032 15.8898 29.0873 16.2625 29.4488 16.6127C29.991 17.1775 30.5219 17.6858 30.4993 18.2393C30.4767 18.7928 29.9006 19.3689 29.3245 19.9337L24.6593 24.6103L23.0552 23.0063L27.856 18.2167L26.7716 17.1323L25.1676 18.7251L20.9316 14.4891L25.2692 10.1627C25.7098 9.72214 26.444 9.72214 26.862 10.1627L29.5053 12.806C29.9458 13.2239 29.9458 13.9581 29.5053 14.3987ZM9.5 25.9319L20.299 15.1216L24.535 19.3576L13.736 30.1679H9.5V25.9319Z",
    fill: "#0F0742"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7e87acaac0cc845ba522a3d2ee178c50.svg";
export { ForwardRef as ReactComponent };